import styled from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 56px 28px;
        gap: 40px;
    `,

    "TitleDiv": styled.div`
        display: flex;
        justify-content: space-between;

        & > h2 {
            ${({ theme }) => theme.font["xlarge-semibold"]};
        }

        & > button {
            display: flex;
            align-items: center;
            gap: 4px;

            & > p {
                ${({ theme }) => theme.font["xsmall-regular"]};
            }

            & > img {
                height: 10px;
            }
        }
    `,

    "EventList": styled.div`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
    "EventElement": styled.button`
        position: relative;
        display: flex;
        padding: 16px;
        border-radius: 8px;

        & > img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center center;
            border-radius: 8px;
        }
    `,
    "ShadowDiv": styled.div`
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgb(0,0,0,0.4);
        border-radius: 8px;
    `,
    "EventTitleDiv": styled.div`
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 4px;
        z-index: 1;

        & > h1 {
            color: ${({ theme }) => theme.color["white"]};
            ${({ theme }) => theme.font["large-semibold"]};
            text-align: left;
        }

        & > p {
            color: ${({ theme }) => theme.color["white"]};
            ${({ theme }) => theme.font["small-regular"]};
            text-align: left;
        }

        & > h2 {
            background-color: ${({ theme }) => theme.color["black"]};
            ${({ theme }) => theme.font["xsmall-bold"]};
            padding: 4px 8px;
            border-radius: 9999px;
            margin-top: 4px;

            color: ${({ theme, $type }) => {
            if ($type === 0) return theme.color["orange"]
            else if ($type === 1) return theme.color["green"]
            else if ($type === 2) return theme.color["blue"]
            else if ($type === 3) return theme.color["red"]
            else if ($type === 4) return theme.color["grey3"]
        }};
        }
    `,
    "EventControlDiv": styled.div`
        width: 72px;
        min-width: 72px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: end;
        z-index: 1;

        & > p {
            color: ${({ theme }) => theme.color["white"]};
            ${({ theme }) => theme.font["xtiny-regular"]};
            padding: 4px 8px;
            border-radius: 9999px;

            background-color: ${({ theme, $type }) => {
            if ($type === 1) return theme.color["red"]
            else if ($type === 2) return theme.color["orange"]
            else if ($type === 3) return theme.color["blue"]
            else if ($type === 4) return theme.color["green"]
            else if ($type === 5) return theme.color["grey4"]
        }};
        }

        & > h2 {
            display: flex;
            align-items: center;
            gap: 2px;
            color: ${({ theme }) => theme.color["white"]};
            ${({ theme }) => theme.font["small-bold"]};

            & > img {
                height: 12px;
            }
        }

        & > button {
            width: 100%;
            background-color: ${({ theme }) => theme.color["black"]};
            ${({ theme }) => theme.font["xsmall-semibold"]};
            color: ${({ theme }) => theme.color["white"]};
            border: 1px solid ${({ theme }) => theme.color["white"]};
            border-radius: 4px;
            padding: 4px 0;
        }
    `,

    "Option": styled.p`
        ${({ theme }) => theme.font["xsmall-medium"]};
    `,
}